import type React from 'react'

interface BackgroundLinesProps {
  className?: string
}

const BackgroundLines: React.FC<BackgroundLinesProps> = ({ className }) => {
  return (
    <svg
      width="703"
      height="547"
      viewBox="0 0 703 547"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`pointer-events-none ${className}`}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_2356_191)">
        <path
          d="M0.805176 546.245L384.829 128.418"
          stroke="url(#paint0_linear_2356_191)"
          strokeMiterlimit="10"
        />
        <path
          d="M0.805176 403.401L464.093 139.678"
          stroke="url(#paint1_linear_2356_191)"
          strokeMiterlimit="10"
        />
        <path
          d="M0.805176 238.981L543.336 150.918"
          stroke="url(#paint2_linear_2356_191)"
          strokeMiterlimit="10"
        />
        <path
          d="M0.805176 80.8062L622.609 162.174"
          stroke="url(#paint3_linear_2356_191)"
          strokeMiterlimit="10"
        />
        <path
          d="M0.805176 -71.1568L701.873 173.415"
          stroke="url(#paint4_linear_2356_191)"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2356_191"
          x1="0.719205"
          y1="337.331"
          x2="384.915"
          y2="337.331"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2356_191"
          x1="0.70146"
          y1="271.54"
          x2="464.197"
          y2="271.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2356_191"
          x1="0.68372"
          y1="194.949"
          x2="543.458"
          y2="194.949"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2356_191"
          x1="0.665973"
          y1="121.49"
          x2="622.748"
          y2="121.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2356_191"
          x1="0.648228"
          y1="51.129"
          x2="702.03"
          y2="51.129"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.75" stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2356_191">
          <rect
            width="703"
            height="619"
            fill="white"
            transform="matrix(1 0 0 -1 0 547)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default BackgroundLines
